import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const FAQS = [
  {
    q: "How does renting work?",
    a: "Choose your outfit, select the date and size, pay the rental and refundable deposit, and receive it before your event. Return it after.",
  },
  {
    q: "How far in advance should I book?",
    a: "For weddings and festive seasons, [7 to 15] days ahead is best. Last-minute bookings are possible subject to availability.",
  },
  {
    q: "What is the rental period?",
    a: "Standard rental is [3 to 4] days. Extended rental is available on request.",
  },
  {
    q: "Do I need to pay a security deposit?",
    a: "Yes, a refundable deposit of [amount or % of outfit value], returned after inspection [within X days].",
  },
  {
    q: "What if the size doesn't fit?",
    a: "We recommend sharing your measurements or visiting for a trial. Minor alterations (like hooks or hem tape) are allowed; cutting or stitching is not. [Size exchange policy]",
  },
  {
    q: "Are the clothes clean and hygienic?",
    a: "Yes. Every outfit is inspected, professionally cleaned, sanitized and packed before delivery.",
  },
  {
    q: "Are the outfits really in good condition?",
    a: "Yes. Items with damage or fading are restored or removed from the collection.",
  },
  {
    q: "Can I try before renting?",
    a: "Yes, at our store by appointment. [Home trial availability]",
  },
  {
    q: "Do you deliver in Indore?",
    a: "Yes, doorstep delivery and pickup across Indore. [Charges / areas covered]. Store pickup is also available.",
  },
  {
    q: "What if there is a stain or damage?",
    a: "Normal wear and small marks are fine. Do not wash or dryclean the outfit yourself. Major damage or loss is charged per our policy, adjusted against the deposit.",
  },
  {
    q: "Can I cancel or change my booking?",
    a: "Yes, per our cancellation terms. Changes of date or size are free up to [X hours] before delivery.",
  },
  {
    q: "What if I return the outfit late?",
    a: "A late fee of [₹ per day] applies after the grace period.",
  },
  {
    q: "Do you have outfits for kids?",
    a: "Yes: boys' and girls' ethnic and festive wear, in [age range].",
  },
  {
    q: "Is my personal information safe?",
    a: "Yes. We collect only what we need and never sell it. See our Privacy Policy.",
  },
  {
    q: "How do I pay?",
    a: "UPI, cards, net banking and cash at store [confirm].",
  },
];

export default function FAQ() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box>
      <Box sx={{ textAlign: "center", mb: { xs: 3, md: 5 } }}>
        <Typography
          sx={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: "#977743",
            mb: 1.2,
          }}
        >
          Need to know
        </Typography>

        <Typography
          component="h2"
          sx={{
            fontFamily: "Georgia, serif",
            fontSize: { xs: 30, md: 40 },
            fontWeight: 400,
            letterSpacing: "-0.03em",
            color: "#171717",
          }}
        >
          Frequently asked questions
        </Typography>
      </Box>

      <Box
        sx={{
          maxWidth: 860,
          mx: "auto",
          background: "#fff",
          border: "1px solid #ddd7ce",
        }}
      >
        {FAQS.map((item, index) => {
          const id = `faq-${index}`;
          const isOpen = expanded === id;

          return (
            <Accordion
              key={id}
              expanded={isOpen}
              onChange={(_, open) => setExpanded(open ? id : false)}
              disableGutters
              elevation={0}
              square
              sx={{
                background: "transparent",
                borderBottom:
                  index === FAQS.length - 1 ? "none" : "1px solid #eee9e2",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                aria-controls={`${id}-content`}
                id={`${id}-header`}
                expandIcon={
                  isOpen ? (
                    <RemoveIcon sx={{ fontSize: 20, color: "#977743" }} />
                  ) : (
                    <AddIcon sx={{ fontSize: 20, color: "#171717" }} />
                  )
                }
                sx={{
                  px: { xs: 2, md: 3 },
                  py: 0.5,
                  minHeight: 64,
                  "&:hover": { background: "#faf8f5" },
                  "& .MuiAccordionSummary-content": { my: 1.5 },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Georgia, serif",
                    fontSize: { xs: 16, md: 18 },
                    lineHeight: 1.4,
                    color: isOpen ? "#977743" : "#171717",
                    pr: 2,
                  }}
                >
                  {item.q}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ px: { xs: 2, md: 3 }, pt: 0, pb: 3 }}>
                <Typography
                  sx={{
                    fontSize: 14,
                    lineHeight: 1.9,
                    color: "#67625c",
                    maxWidth: 720,
                  }}
                >
                  {item.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Box>
  );
}